module.exports = __webpack_public_path__ + "media/components/country-flag/static/tv-c75afdde63ae0e1e205c5dfd653afffe.svg";